"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const toolkit_1 = require("@reduxjs/toolkit");
const react_native_1 = require("react-native");
const personalIdentificationSlice_1 = require("./personalIdentificationSlice");
const screenConstants_1 = require("../../../constants/screenConstants");
const useAppNavigation_1 = __importDefault(require("../../../hooks/useAppNavigation"));
const navContainer_1 = __importDefault(require("../../../components/navContainer/navContainer"));
const store_1 = require("../../../store");
const input_1 = __importStar(require("../../../components/input/input"));
const utils_1 = require("../../../utils/utils");
const choices_1 = require("../../../utils/choices");
const imageInput_1 = __importDefault(require("../../../components/documentUpload/imageInput/imageInput"));
const primaryButton_1 = __importDefault(require("../../../components/primaryButton/primaryButton"));
const analytics_1 = require("../../../utils/analytics/analytics");
const text_1 = __importStar(require("../../../components/text/text"));
const colors_1 = __importDefault(require("../../../styles/colors"));
const PersonalIdentification = () => {
    const dispatch = (0, store_1.useAppDispatch)();
    const navigation = (0, useAppNavigation_1.default)();
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const userData = (0, store_1.useAppSelector)((state) => state.home.user_data);
    const [errors, setErrors] = (0, react_1.useState)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [bvnState, setBvn] = (0, react_1.useState)(userData ? userData.personal_identification.bvn : '');
    const [typeId, setTypeId] = (0, react_1.useState)(userData ? userData.personal_identification.nigeria_identification_type : '');
    const [idNumber, setIdNumber] = (0, react_1.useState)(userData ? userData.personal_identification.identification_number : '');
    const [idDocument, setIdDocument] = (0, react_1.useState)(userData ? userData.personal_identification.identity_document : {});
    const [idDocumentName, setIdDocumentName] = (0, react_1.useState)(userData && userData.personal_identification.identity_document.fileName
        ? userData && userData.personal_identification.identity_document.fileName
        : '');
    // SUBMIT FORM DATA
    const submitForm = async () => {
        setIsLoading(true);
        let payload = {
            bvn: bvnState.toString(),
            nigeria_identification_type: typeId,
            identification_number: idNumber.toString(),
        };
        const formDataPayload = new FormData();
        Object.entries(payload).forEach((entry) => {
            formDataPayload.append(entry[0], entry[1]);
        });
        // only add identity document if it changes
        if (userData && idDocument !== userData.personal_identification.identity_document.uri) {
            // @ts-ignore
            const file = await fetch(idDocument).then((r) => r.blob());
            payload = {
                ...payload,
                identity_document: file,
            };
            // @ts-ignore
            formDataPayload.append('identity_document', file, idDocumentName);
        }
        const result = await dispatch((0, personalIdentificationSlice_1.submitPersonalIdentification)(formDataPayload));
        logEventWithExtraProperties('api_call', {
            name: 'submit_personal_identification',
            status: 'submitted',
            location: 'screen_PersonalIdentification',
        });
        if ((0, toolkit_1.isFulfilled)(result)) {
            logEventWithExtraProperties('api_call', {
                name: 'submit_personal_identification',
                status: 'success',
                location: 'screen_PersonalIdentification',
            });
            setErrors(undefined);
            setIsLoading(false);
            navigation.navigate(screenConstants_1.PROFILE_SCREEN);
        }
        else {
            logEventWithExtraProperties('api_call', {
                name: 'submit_personal_identification',
                status: 'fail',
                location: 'screen_PersonalIdentification',
            });
            setErrors(result.payload);
            setIsLoading(false);
        }
    };
    const validFormats = 'Upload Image (PNG, JPEG, PDF)';
    return (react_1.default.createElement(navContainer_1.default, { errors: errors, isLoading: isLoading, footer: react_1.default.createElement(primaryButton_1.default, { title: "Save", onPress: submitForm, disabled: false, eventName: "personalIdentification_save" }), childrenTitle: "Identification details" },
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_NUMBER, isBVN: true, label: "BVN", placeholder: "BVN", setValue: setBvn, value: bvnState, error: (0, utils_1.getError)('bvn', errors) }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PICKER, label: "Type of ID document", choices: choices_1.typeDocumentChoices, setValue: setTypeId, value: typeId || '', error: (0, utils_1.getError)('nigeria_identification_type', errors) }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_NUMBER, label: "ID number", placeholder: "ID number", setValue: setIdNumber, value: idNumber, error: (0, utils_1.getError)('identification_number', errors) }),
        react_1.default.createElement(react_native_1.View, { style: { top: 8 } },
            react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE_SIZE_12, color: colors_1.default.COLOR_PRIMARY }, validFormats)),
        react_1.default.createElement(imageInput_1.default, { toUploadTitle: "Upload ID Document", image: idDocument, 
            // @ts-ignore
            setImage: setIdDocument, setImageName: setIdDocumentName, error: (0, utils_1.getError)('identity_document', errors) })));
};
exports.default = PersonalIdentification;
